import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'components/LoadingSpinner';
import FormikArrayCheckbox from '../FormikArrayCheckbox';
import useStorageLocations from '../../../../../StorageLocations/hooks/useStorageLocations';

const StorageLocationsFilter = () => {
  const { loading, fetchStorageLocations } = useStorageLocations();
  const [storageLocations, setStorageLocations] = useState([]);

  useEffect(() => {
    const loadLocation = async () => {
      const { data } = await fetchStorageLocations();
      setStorageLocations(data);
    };
    loadLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <LoadingSpinner message="" label="Loading storage locations" />
      ) : (
        <>
          {storageLocations?.length > 0 ? (
            storageLocations?.map(storageLocation => (
              <div
                key={storageLocation?.id}
                className="flex items-center pl-2 py-6px"
              >
                <FormikArrayCheckbox
                  name="storageIds"
                  value={storageLocation.id}
                >
                  {storageLocation?.name}
                </FormikArrayCheckbox>
              </div>
            ))
          ) : (
            <div className="text-neutral-60 text-sm ">
              No storage locations found.
            </div>
          )}
        </>
      )}
    </>
  );
};

export default StorageLocationsFilter;
